<template>
      
    <div class="p-4 bg-red-900 min-h-screen flex justify-center items-center">
        <div class="w-full max-w-md">
            <logo  />
            <form class="mt-6 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="store">
                <div class="px-10 py-12">
                    <h1 class="text-center font-bold text-3xl">Resetear Contraseña</h1>
                    <div class="mx-auto mt-6 w-24 border-b-2" />
                    <!-- <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" /> -->
                    <text-input v-model="form.password" :error="form.errors.password" class="mt-6" type="password" autocomplete="new-password" label="Nueva Contraseña" />
                    <text-input v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mt-6" type="password"  label="Confirmar Nueva Contraseña" />
                    <div class=" py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                        <loading-button :loading="form.processing" class="ml-auto btn-login" type="submit">Resetear Contraseña</loading-button>
                    </div>
                </div>
            </form>
        </div>
      
    </div>
</template>

<script>
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'


export default {
  metaInfo: { title: 'Registro' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    Logo,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        // email: null,
        password: null,
        password_confirmation:null,
        token:this.$page.props.token,

      }),
    }
  },
  mounted(){
       
  },
  watch: {
        '$page.props.flash.success':function(newError, oldError){
            this.$alert(newError, 'Confirmacion de Cambio de contraseña', {
                confirmButtonText: 'OK'
            });
        },
        '$page.props.errors':function (newError, oldError) {
            if(Object.keys(newError).length > 0){
                let html = '<div><h1><span>El formulario contiene los siguientes errores:</span></h1><br>'
                for (let clave in newError){
                    html += '<ul><li style="color:teal">'+newError[clave]+'</li></ul><br></div>'
                }
                const h = this.$createElement;
                const message = h("div", {domProps:{innerHTML: html}})

                this.$msgbox({
                    title: 'Aviso',
                    message:message,
                    confirmButtonText: 'OK',
                });
            }
        },
        '$page.props.flash.error':function(newError, oldError){
            this.$alert(newError, 'Aviso', {
                confirmButtonText: 'OK'
            });
        },
    },
  methods: {
    store() {
      this.form.post(this.route('reset.password.post'))
    },
  },
}
</script>
